/** fetching layer is handled by legacy code in AccountModelImageService, we are caching the result here so it can be used in the account data */

import { createSharedSlice } from '@luna/state';

type accountId = string;
export type AccountImagesById = Record<
    accountId,
    {
        imageBase64?: string;
        imageBigBase64?: string;
    }
>;

export type AccountImagesState = {
    images: AccountImagesById;
};

export const useAccountImages = createSharedSlice({
    name: 'products/accountImageSlice',
    initialState: {
        images: {},
    } as AccountImagesState,
    reducers: {
        addAccountImageBase64: (
            state,
            action: { payload: { accountId: string; imageBase64?: string } },
        ) => {
            const { accountId, imageBase64 } = action.payload;
            if (!state.images[accountId]) {
                state.images[accountId] = {
                    imageBase64,
                };
            }
            state.images[accountId].imageBase64 = imageBase64;
        },
        addAccountImageBigBase64: (
            state,
            action: { payload: { accountId: string; imageBigBase64?: string } },
        ) => {
            const { accountId, imageBigBase64 } = action.payload;
            if (!state.images[accountId]) {
                state.images[accountId] = {
                    imageBigBase64,
                };
            }
            state.images[accountId].imageBigBase64 = imageBigBase64;
        },
    },
});

export const { addAccountImageBase64, addAccountImageBigBase64 } = useAccountImages.dispatchActions;

export const selectAccountImagesById = (): AccountImagesById => useAccountImages.getState().images;

export const selectAccountImage = <AccountId extends keyof AccountImagesById>(
    accountId: AccountId,
): AccountImagesById[AccountId] => useAccountImages.getState().images[accountId];
